import { useFetcher } from '@remix-run/react';
import { useEffect } from 'react';
import type { Recommendation } from '~/interfaces/recommendation';

export interface RecommendationData {
  isLoading: boolean;
  recommendations: Recommendation[];
  boostedRecommendations: Recommendation[];
}

const useRecommendations = () => {
  const fetcher = useFetcher();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    fetcher.load('/recommendations_data?index');
  }, []);

  return (fetcher?.data || {
    recommendations: [],
    boostedRecommendations: [],
    isLoading: true,
  }) as RecommendationData;
};

export default useRecommendations;
